import { render, staticRenderFns } from "./AddSkill.vue?vue&type=template&id=55b9f160&scoped=true&"
import script from "./AddSkill.vue?vue&type=script&lang=js&"
export * from "./AddSkill.vue?vue&type=script&lang=js&"
import style0 from "./AddSkill.vue?vue&type=style&index=0&id=55b9f160&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b9f160",
  null
  
)

export default component.exports